import React from 'react';

import { getSubAbas } from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';

const MaisOpcoesAjuda: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>Estrutura especial</ContainerConteudo>
    </>
  );
};

export default MaisOpcoesAjuda;
